import { useEffect } from 'react';

import { useCurrentUser } from '@/lib/hooks/use-current-user';

declare global {
  interface Window {
    $crisp: unknown[];
    CRISP_WEBSITE_ID: string;
  }
}

if (typeof window !== 'undefined') {
  window.$crisp = [];
  window.CRISP_WEBSITE_ID = '87e8cb76-9dfe-4b1e-9b6e-bc2bab6440ed';
}

export const CrispChat = () => {
  const user = useCurrentUser();

  useEffect(() => {
    const s = document.createElement('script');
    s.src = 'https://client.crisp.chat/l.js';
    s.async = true;
    document.getElementsByTagName('head')[0]?.appendChild(s);
  }, []);

  useEffect(() => {
    if (user.data) {
      window.$crisp.push([
        'set',
        'user:nickname',
        user.data.firstName + ' ' + user.data.lastName,
      ]);
      window.$crisp.push(['set', 'user:email', user.data.email]);
    }
  }, [user.data]);

  return null;
};
